"use client";

import React, { useState, useEffect } from "react";
import { useFXRate } from "@/hooks/use-fx-rate";

const ChevronRightIcon = () => (
  <svg
    className="w-3 h-3"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 5l7 7-7 7"
    />
  </svg>
);

const ChevronUpIcon = () => (
  <svg
    className="w-6 h-6"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5 15l7-7 7 7"
    />
  </svg>
);

const CheckIcon = () => (
  <svg
    className="w-3 h-3"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5 13l4 4L19 7"
    />
  </svg>
);

interface CurrencyRate {
  country: string;
  flag: string;
  fromAmount: string;
  fromCurrency: string;
  toAmount: string;
  toCurrency: string;
}

export const CurrencyRates: React.FC = () => {
  const [usdToCopRate, setUsdToCopRate] = useState<number | null>(null);
  const { rate, isLoading } = useFXRate();

  useEffect(() => {
    if (!isLoading) {
      setUsdToCopRate(rate || 4000);
    }
  }, [rate, isLoading]);

  if (isLoading && !usdToCopRate) {
    return (
      <div className="w-full max-w-[344px]">
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <div className="animate-pulse">
            <div className="h-4 bg-gray-200 rounded w-3/4 mb-4"></div>
            <div className="space-y-3">
              <div className="h-4 bg-gray-200 rounded"></div>
              <div className="h-4 bg-gray-200 rounded"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full max-w-[344px]">
      {/* Header */}
      <div className="mb-4">
        <h2 className="text-xl font-light text-gray-900 font-lato">
          Exchange Rates
        </h2>
      </div>

      {/* Rates Card */}
      <div className="bg-white rounded-lg border-0 shadow-sm">
        <div className="p-6 pb-4">
          <div className="flex items-center gap-2">
            <span className="text-base font-light text-gray-900 font-lato">
              Transfer from
            </span>

            {/* Country Selector */}
            <div className="flex items-center gap-1">
              <span className="text-base">🇺🇸</span>
              <span className="text-base font-light text-gray-900 font-lato">
                United States
              </span>
              <ChevronUpIcon />
            </div>
          </div>
          <span className="text-base font-light text-gray-900 font-lato">
            to:
          </span>
        </div>

        <div className="px-6 pt-0">
          <div className="space-y-2">
            <div className="flex items-center gap-2 py-2">
              <span className="text-2xl">🇨🇴</span>
              <div className="flex-1">
                <div className="font-lato text-base font-light text-gray-900 mb-2">
                  Colombia
                </div>
                <div className="flex items-center gap-1 text-base font-lato text-gray-900">
                  <span>$ 1.00 USD</span>
                  <span>=</span>
                  <span>${usdToCopRate?.toLocaleString()} COP</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrencyRates;
